import * as R from 'ramda';
import {
  countries,
  MASK_OF_PHONE_NUMBER,
} from '@/utils/constants';

const getPhoneMask = (country) => R.pathOr(MASK_OF_PHONE_NUMBER, [country, 'phoneMask'], countries);

export default getPhoneMask;
